import styled from 'styled-components'

export const EnteredWord = styled.p`
  color: #334155;
  font-size: 24px;
  font-weight: 500;
`

export const WordLength = styled.span`
  color: #0f172a;
  font-size: 24px;
  font-weight: 600;
`
